import axios from 'axios';
import API_BASE_URL from '../apiConfig';

// Moving a signed-in user to another NorthAI app (Lead Concierge, and back)
// used to put the JWT in the URL (?token=), where it ends up in browser
// history, logs and Referer headers. Now the sending app asks its backend for
// a one-time code (60 s, single use) and links with ?handoff=<code>; the
// receiving app exchanges it with its own backend.

export function withParam(url, key, value) {
  const u = new URL(url, window.location.origin);
  u.searchParams.set(key, value);
  return u.toString();
}

// URL to open `appUrl` signed in. Falls back to the bare URL (the user signs
// in there) when no code can be issued.
export async function handoffUrl(appUrl) {
  try {
    const res = await axios.post(`${API_BASE_URL}/api/auth/handoff-code`, {}, { withCredentials: true });
    if (res.data?.code) return withParam(appUrl, 'handoff', res.data.code);
  } catch (err) {
    console.warn('Handoff code unavailable — opening without sign-in', err);
  }
  return appUrl;
}

// If this page was opened with ?handoff=<code>, remove it from the address
// bar and exchange it for a token. Returns the token, or null.
export async function consumeHandoff() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get('handoff');
  if (!code) return null;
  params.delete('handoff');
  const rest = params.toString();
  window.history.replaceState({}, '', rest ? `${window.location.pathname}?${rest}` : window.location.pathname);
  try {
    const res = await axios.post(`${API_BASE_URL}/api/auth/handoff-exchange`, { code }, { withCredentials: true });
    return res.data?.access_token || null;
  } catch (err) {
    console.warn('Handoff code could not be redeemed', err);
    return null;
  }
}
